import { LayoutData } from "../Structur/Aconlayout";
import { useEffect} from "react";
import { Card, Space } from "antd";
import { Divider } from "antd";
import { Collapse } from "antd";
import { LogoImg } from "../Components/LogoImg";


export const About = () => {
  const { aktSumsComponent } = LayoutData();
  useEffect(() => {
    aktSumsComponent(<>Copyright by Ing. Christian Pohanka</>);
  });

 
  const text1 = (
    <>
      PUBLIC_URL = "/aconsoft1/" <br /> REACT_APP_PUBLIC_URL="/aconsoft1"
    </>
  );
  const text2 = (
    <>
      &lt;IfModule mod_rewrite.c&gt;
      <br />
      RewriteEngine On
      <br />
      RewriteBase /aconsoft1/
      <br />
      RewriteRule ^index\.html$ - [L]
      <br />
      RewriteCond %&#123;REQUEST_FILENAME&#125; !-f
      <br />
      RewriteCond %&#123;REQUEST_FILENAME&#125; !-d
      <br />
      RewriteRule . /aconsoft1/ [L]
      <br />
      &lt;/IfModule&gt;
    </>
  );

  const text3 = (
    <>
      "name": "aconsoft1",
      <br />
      "homepage": "/aconsoft1/",
      <br />
      <br />
      "build": "env-cmd -f ./.env react-scripts build",
      <br></br>
      "start": "BROWSER=none react-scripts start" so geht jedoch nicht ??????,
      <br></br>
    </>
  );
  const items = [
    {
      key: "1",
      label: 'Eine Datei ".env" im Verzeichnis von "pachage.json"',
      children: <p>{text1}</p>,
    },
    {
      key: "2",
      label: "Im Verzeichnis am Server die Datei .htacces",
      children: <p>{text2}</p>,
    },
    {
      key: "3",
      label: "In der Datei package.json",
      children: <p>{text3}</p>,
    },
  ];
  const onChange = (key) => {
    console.log(key);
  };

  return (
    <div className="page">
      <center>
        <Card>
          <h2>Acon Profi - Datenbankzurgriffe mit React und API</h2>
          <p>
           Zugang zu den klassischen Btrieve Datenbanken 
          </p>
        </Card>
      </center>

      <Collapse
        size="small"
        items={[
          {
            key: "1",
            label: "Kontenrahmen",
            children: (
              <>
                <p>
                  Liste aller Buchhaltungs Konten jeweils eines Jahre
                </p>
              </>
            ),
          },
          {
            key: "2",
            label: "...",
            children: (
              <>
                <p>
                 kommt
                </p>
              </>
            ),
          },         
        ]}
      />
      <center>
        <h3>Verwaltung der Benutzer</h3>
      </center>
      <Collapse
        size="small"
        items={[
          {
            key: "1",
            label: "Anmeldung",
            children: (
              <>
                <p>
                  Die Anmeldung zum Sstem erfolgt über Selbstregistrierung
                  mittels Email Adresse und Passwort, wobei die Email Adresse
                  überprüft wird. Damit ist das Anmelden erst nach Bestätigung
                  durch den Link im Email möglich. Damit hat der Benutzer jedoch
                  noch keine besonderen Rechte, ausser seinen Account wieder zu
                  löschen und die persönlichen Daten zu ergänzen.
                </p>
              </>
            ),
          },
          {
            key: "2",
            label: "Benutzerrollen",
            children: (
              <>
                <p>
                  Das Rollensystem der Berechtigungen unterscheidet folgende
                  Stufen der Berechtigung:<br/><b>
                  Kunde
                  <br />
                  Benutzer
                  <br />
                  Verwalter
                  <br />
                  Admin
                  <br />
                  Superadmin
                  <br />
                  </b>
                </p>
              </>
            ),
          },
          {
            key: "3",
            label: "Selbstverwaltung",
            children: (
              <>
                <p>
                  Jede Person kann seine eigenen persönlichen Daten ändern, ein
                  Bild als Avatar hoch laden und seinen Account löschen, wodurch
                  alle Beziehungen ebenfalls gelöscht werden.
                </p>
              </>
            ),
          },
          {
            key: "4",
            label: "Verwaltung durch den Administrator",
            children: (
              <>
                <p>
                  Der Admin und der Verwalter haben die Berechtigung zur
                  Bearbeitung alle Benutzeraccounts und zur Vergabe der
                  Benutzerrollen.
                </p>
              </>
            ),
          },
         
        ]}
      />

      <Divider orientation="center">
        <h3>Technische Hinweise zum Einrichten von React auf der Synology</h3>
        <p>Damit die React APP im Unterverzeichnis "aconsoft1" läuft</p>
      </Divider>

      <Collapse items={items} onChange={onChange} />
      <center>
        <Space direction="vertical" size={16}>
          <Card
            size="small"
            title="...es gibt immer was zu Lernen"
            style={{
              width: 500,
            }}
          >
            <LogoImg />
          </Card>
        </Space>
      </center>
    </div>
  );
};
